export default __webpack_public_path__ + "static/media/test-white.5fe5e41b.svg";